import React, { useEffect } from 'react'

function Navigation({ isOpen, onClose }) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
  }, [isOpen])

  const handleClose = () => {
    onClose()
  }

  // 🔽 Função para rolar suavemente até a seção
  const scrollToSection = (id) => {
    const section = document.querySelector(id)
    if (section) {
      section.scrollIntoView({ behavior: 'smooth', block: 'start' })
      handleClose()
    }
  }

  const overlayClass = isOpen ? 'opacity-90' : 'opacity-0 pointer-events-none'
  const translateClass = isOpen ? 'translate-x-0' : 'translate-x-full'

  return (
    <section id='nav' className='transition-all'>
      {/* Fundo escuro do menu */}
      <div
        className={`fixed inset-0 z-30 bg-black ${overlayClass} backdrop-blur-2xl backdrop-filter duration-500 ease-in-out`}
        onClick={handleClose}
      />

      {/* Menu lateral */}
      <nav
        className={`fixed inset-y-0 right-0 z-40 flex w-10/12 flex-col justify-center gap-8 bg-blue p-8 shadow-lg duration-1000 ease-in-out md:w-1/3 ${translateClass}`}
      >
        <ul className='flex flex-col gap-3'>
          <li>
            <button
              onClick={() => {
                window.scrollTo({ top: 0, behavior: 'smooth' })
                handleClose()
              }}
              className='text-left text-3xl font-semibold uppercase text-white transition-colors duration-200 hover:text-yellow'
            >
              Página Inicial
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection('#nossos-servicos')}
              className='text-left text-3xl font-semibold uppercase text-white transition-colors duration-200 hover:text-yellow'
            >
              Nossos Serviços
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection('#quem-somos')}
              className='text-left text-3xl font-semibold uppercase text-white transition-colors duration-200 hover:text-yellow'
            >
              Quem Somos
            </button>
          </li>
          <li>
            <button
              onClick={() => scrollToSection('#contatos')}
              className='text-left text-3xl font-semibold uppercase text-white transition-colors duration-200 hover:text-yellow'
            >
              Contatos
            </button>
          </li>
        </ul>
      </nav>
    </section>
  )
}

export default Navigation
